import React, { useState, useEffect } from 'react';

const LogoSwitcher = () => {
  // 以同步方式計算初始 Logo，避免首次渲染時 src="" 觸發瀏覽器重新下載整頁
  const [logoSrc, setLogoSrc] = useState(() =>
    window.innerWidth > 768 ? '/img/logo.png' : '/img/logo_2.png'
  );
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    // 設置初始 Logo
    const updateLogo = () => {
      const isPC = screenWidth > 768;
      setLogoSrc(isPC ? '/img/logo.png' : '/img/logo_2.png');
    };

    // 監控滾動事件
    const handleScroll = () => {
      const isPC = screenWidth > 768;
      if (window.scrollY > 50) {
        setLogoSrc(isPC ? '/img/logo_2.png' : '/img/logo.png');
      } else {
        setLogoSrc(isPC ? '/img/logo.png' : '/img/logo_2.png');
      }
    };

    // 更新螢幕寬度
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    // 初始更新
    updateLogo();

    // 註冊事件監聽
    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleResize);

    // 清理事件監聽
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
    };
  }, [screenWidth]);

  return (
    <img
      id="logo"
      src={logoSrc}
      alt="Logo"
      style={{ maxHeight: '45px', width: 'auto', marginBottom: '15px',marginRight: '1%' }}
    />
  );
};

export default LogoSwitcher;
